// import reportShopList from '../components/reportShop/reportShopList.vue'
// import addReportShop from '../components/reportShop/addReportShop.vue'
// import viewReportShop from '../components/reportShop/viewReportShop.vue'

export default [
    {
        path: 'reportShop/reportShopList',
        component: resolve => require(['@/components/reportShop/reportShopList'],resolve),
        name:"ReportShopList",
        meta:{
            id:'765',
            node:'reportShop',
            url:'reportShopList',
        }
    },
    {
        path: 'reportShop/addReportShop',
        component: resolve => require(['@/components/reportShop/addReportShop'],resolve),
        name:"AddReportShop",
        meta:{
            // id:'765',
            node:'reportShop',
            url:'addReportShop',
        }
    },
    {
        path: 'reportShop/viewReportShop',
        component: resolve => require(['@/components/reportShop/viewReportShop'],resolve),
        name:"ViewReportShop",
        meta:{
            // id:'765',
            node:'reportShop',
            url:'viewReportShop',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/reportShop.js